import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { ZitaLogo, ZitaWordmark } from '@/components/ZitaLogo';
import { PublicFooter } from '@/components/PublicFooter';
import { HoneypotFields, useHoneypot } from '@/components/Honeypot';
import { AUTH } from '@/constants/testIds';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const honeypot = useHoneypot();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/forgot-password', {
        email: email.trim().toLowerCase(),
        ...honeypot.getValues(),
      });
      // Server always returns 200 (does not leak email existence, and silently
      // succeeds honeypot-tripped requests). Frontend shows the same message.
      setSent(true);
    } catch (e) {
      toast.error('Something went wrong');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-10">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <ZitaLogo size={44} />
          <ZitaWordmark className="text-3xl" />
        </Link>
        <form onSubmit={submit} className="zita-card p-8 w-full max-w-md space-y-4">
          <h1 className="font-serif text-3xl text-zita-espresso">Reset your password</h1>
          {sent ? (
            <p className="text-sm text-zita-mocha">
              If that email is registered, we sent a reset link. Check your inbox.
            </p>
          ) : (
            <>
              <p className="text-sm text-zita-mocha">Enter your email and we&apos;ll send you a link.</p>
              <HoneypotFields inputRef={honeypot.websiteRef} />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid={AUTH.forgotEmail}
                placeholder="you@example.com"
                className="zita-input w-full px-4 py-3 text-sm"
              />
              <button
                type="submit"
                disabled={busy}
                data-testid={AUTH.forgotSubmit}
                className="zita-btn-primary w-full"
              >
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
            </>
          )}
          <div className="text-center">
            <Link to="/login" className="text-sm text-zita-cocoa hover:underline">Back to sign in</Link>
          </div>
        </form>
      </main>
      <PublicFooter />
    </div>
  );
};

export default ForgotPassword;
